import { hasSessionFOMOD } from "./guards";
import { ProcessCanceled } from "../../../util/CustomErrors";
// Helper function to check if there's an active FOMOD dialog
export function hasActiveFomodDialog(api) {
    const state = api.getState();
    if (!state || !hasSessionFOMOD(state.session)) {
        return false;
    }
    const activeInstanceId = state.session.fomod.installer?.dialog?.activeInstanceId;
    return !!activeInstanceId;
}
export const getChoicesFromState = (api, instanceId) => {
    const state = api.getState();
    if (!state || !hasSessionFOMOD(state.session)) {
        throw new ProcessCanceled("FOMOD state missing after installation");
    }
    const dialogState = state.session.fomod.installer?.dialog?.instances?.[instanceId]?.state;
    const choices = dialogState?.installSteps === undefined
        ? undefined
        : dialogState.installSteps.map((step) => {
            const ofg = step.optionalFileGroups || {
                group: [],
                order: "Explicit",
            };
            return {
                name: step.name,
                groups: (ofg.group || []).map((group) => ({
                    name: group.name,
                    choices: group.options
                        .filter((opt) => opt.selected)
                        .map((opt) => ({ name: opt.name, idx: opt.id })),
                })),
            };
        });
    return choices;
};
